module.exports = __webpack_public_path__ + "img/growcify-aasife-biryani-banner.17b1a1bb.png";